import React, { useEffect, useState } from "react";
import axios from "axios";
import PDFfile from "./features/PDFfile.js";
import Data, {DataAPi} from "./variable/dataVariable.js"

function Qrcode() {
        const [data, setData] = useState([]);
        const [dataFilter, setDataFilter] = useState("0")
        const [value, setValue] = useState({
            attr: ""
        })
        const dataFilterSet = [ Data.Gedung, Data.RuanganFilter, Data.Kategori ]

        const handleSubmit = ((e) => {
            e.preventDefault();
            axios.get(DataAPi.urlGetFilter + value.attr)
            .then(res => {
                setData(res.data)
                console.log(data);
                
                
                
            })
            .catch(err => {
                console.log(err);
                
            })

        })

        useEffect(() => {
            const getAset = async() => {
                await axios.get(DataAPi.urlGetAll)
                .then(res => {
                    setData(res.data)
                })
                .catch(err => console.log(err));
            }
            getAset();
        },[]);
    
    return (
        <>
            <div className="container">
            <div className="row g-3 p-5 bg-light input-group-lg fw-semibold rounded">
                <form className="container row g-3">
                    <div className="col-md-6">
                        <label className="form-label fs-6" for="TypeFilter">Tampilkan Berdasarkan</label>
                        <select className="form-control mb-4 shadow-sm border-success-subtle" onChange={e => {setDataFilter(e.target.value)}}>
                            <option value="0">Gedung</option>
                            <option value="1">Ruangan</option>
                            <option value="2">Kategori</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fs-6" for="TypeFilter">Tampilkan Berdasarkan</label>
                        <select className="form-control mb-4 shadow-sm border-success-subtle" value={value.attr} onChange={e => setValue({...value, attr: e.target.value})}>
                            <option>Pilih</option>
                            {
                                dataFilterSet[dataFilter].map((data, index) => {
                                    return(
                                        <option value={data.data}>{data.data}</option>
                                    )
                                    
                                })
                            }
                        </select>
                    </div>
                    <div className="col-md-6">
                        <button type="button" className="btn btn-success" onClick={handleSubmit}>Tampilkan</button>
                    </div>
                </form>
            </div>
            </div>
            <PDFfile dataSet={data} dataVal={value}/>
        </>
    )

}

export default Qrcode;